if (!window.cwsProductSizeSync && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  window.cwsProductSizeSync = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    const id = `CwsStickerSize-${data.sectionId}`;
    const source = data.html.getElementById(id);
    const destination = document.getElementById(id);
    if (source && destination) destination.textContent = source.textContent;
  });
}
